export default {
      id: "action-items-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#action-items",
      toString: function () {
        return this.url;
      }
    }